import PopupBasic from 'src/game/components/popups/PopupBasic';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import { Feature } from 'src/replicant/analytics';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (result: boolean) => void;

export default class PopupConfirmTeamVisit extends PopupBasic {
  private petImage: ImageScaleView;
  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      ...opts,
      close: () => opts.close(false),
      zIndex: 10001,
      width: 556,
      height: 555,
      tracking: {
        feature: Feature.MATCH2.TEAM._,
        $subFeature: Feature.MATCH2.TEAM.POPUP_CONFIRM_VISIT,
      },
    });

    this.buttonClose.removeFromSuperview();
    this.message.updateOpts({
      x: 20,
      width: this.box.style.width - 40,
      size: 23,
      y: 120,
    });

    this.petImage = new ImageScaleView({
      superview: this.box,
      width: 200,
      height: 200,
      x: this.box.style.width / 2,
      y: this.box.style.height / 2 + 10,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      image: `assets/ui/species/linepet_dog.png`,
    });

    new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.cancel,
      fontSize: 48,
      font: 'Body',
      width: 228,
      height: 82,
      x: this.box.style.width / 2 - 238,
      y: this.box.style.height - 120,
      labelOffsetX: -6,
      labelOffsetY: -2,
      localeText: () => i18n('basic.cancel'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        opts.close(false);
      },
      tracking: {
        feature: 'popup-confirm-team-visit',
        $subFeature: 'popup-confirm-team-visit-cancel',
      },
    });

    new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.secondary,
      fontSize: 48,
      font: 'Body',
      width: 228,
      height: 82,
      x: this.box.style.width / 2 + 10,
      y: this.box.style.height - 120,
      labelOffsetX: -6,
      labelOffsetY: -2,
      localeText: () => i18n('match2.team.chat.confirmVisit.cta'),
      onClick: async () => {
        sounds.sfx.play('ok');
        opts.close(true);
      },
      tracking: {
        feature: 'popup-confirm-team-visit',
        $subFeature: 'popup-confirm-team-visit-ok',
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/species/linepet_dog.png']);
  }

  public init(opts: { speciesId: string }) {
    super.init({
      title: i18n('match2.team.chat.confirmVisit.title'),
      message: i18n('match2.team.chat.confirmVisit.message'),
    });

    this.petImage.setImage(`assets/ui/species/linepet_${opts.speciesId}.png`);
  }
}
